import {AfterContentInit, Component, QueryList, ViewChildren} from '@angular/core';
import {RadioButton} from 'ionic-angular';
import {TreeNode} from '../../../../../content/shared/interfaces/tree-node.interface';
import {BaseTreeNodeComponent} from '../base-tree-node/base-tree-node.component';

/**
 * Class for the RadioTreeNodeComponent
 * @class RadioTreeNodeComponent
 *
 * @description Radio tree node implementation. Used to facilitate single selection in a tree list
 *
 *
 * @usage
 *
 * ```html
 *
 * <advtech-radio-tree-node
 *  [node]='node'
 *  [isChild]='true'
 *  [value]='value'
 *  (onTreeNodeSelection)='hTreeNodeSelection($event, node)'
 * ></advtech-radio-tree-node>
 * ```
 *
 * # Inputs
 *
 * |name|type|description|
 * |---|---|---|
 * |node|[[TreeNode]]|The node value for this tree node|
 * |isChild|boolean|Is this a child of another node|
 * |value|[[TreeNode]][]|The current value for the input|
 *
 * # Outputs
 *
 * |name|type|description
 * |---|---|---|
 * |onTreeNodeSelection|[EventEmitter]{@link https://angular.io/api/core/EventEmitter}<{value}>|Emits the selected node
 */
@Component({
  selector: 'advtech-radio-tree-node',
  templateUrl: './radio-tree-node.component.html',
})
export class RadioTreeNodeComponent extends BaseTreeNodeComponent implements AfterContentInit {
  isChecked: boolean = false;

  @ViewChildren(RadioButton)
  radioButtons: QueryList<RadioButton>;

  @ViewChildren(RadioTreeNodeComponent)
  radioTreeNodes: QueryList<RadioTreeNodeComponent>;

  ngAfterContentInit() {
    if (this.value && this.value.length) {
      this.isChecked = this.value[0].value === this.node.value;
    }
  }

  /**
   * Emits the tree node selection
   * @param {any} e Value from the ionic input
   * @param {TreeNode} node The tree node
   * @param {boolean} fromChild
   * @returns {void}
   */
  hTreeNodeSelection(e: any, node: TreeNode, fromChild: boolean = false): void {
    const value = e.value && this.isTreeNode(e.value) ? e.value : node;

    if (!fromChild) {
      this.radioButtons.forEach((elm) => {
        if (this.isChecked) {
          elm.checked = false;
          return;
        }
      });
      this.isChecked = !this.isChecked;
      value.checked = this.isChecked;
    }
    this.onTreeNodeSelection.emit({value});
  }

  /**
   * Sets the isCheckd value on child radio tree nodes
   * @param {Array} currentVal
   * @return {void}
   */
  setCheckedForChildren(currentVal = []): void {
    this.radioTreeNodes.length && this.radioTreeNodes.forEach((elm) => {
      if (currentVal.length > 0) {
        elm.isChecked = elm.node.value === currentVal[0].value;
        elm.setCheckedForChildren(currentVal);
      }
      else {
        elm.isChecked = false;
        elm.setCheckedForChildren(currentVal);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/tree/tree-node/radio-tree-node/radio-tree-node.component.ts